import { CaretRight } from "@phosphor-icons/react";
import { useState } from "react";

import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import { Button } from "common/components/ui/Button";
import { Dialog, OverlayDialogContent } from "common/components/ui/Dialog";

import MobileClientDetails from "./MobileClientDetails";

import type { AgencyClient } from "../../../types";

export default function MobileList({ clients }: { clients: AgencyClient[] }) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState<AgencyClient>(null);

  const handleRowClick = (client: AgencyClient) => {
    setSelectedClient(client);
    setIsDetailsOpen(true);
  };

  return (
    <>
      <div className="mt-4 flex justify-between rounded-2xl bg-black-100 px-4 py-2">
        <span className="text-xs">Client</span>
        <span className="pr-20 text-xs">Date added</span>
      </div>

      <div className="mt-2 flex flex-col gap-2">
        {clients.map((client) => {
          const {
            id,
            first_name: firstName,
            last_name: lastName,
            email,
          } = client;

          return (
            <button
              key={id}
              type="button"
              className="flex items-center justify-between gap-4 rounded-3xl border border-black-200 p-3"
              onClick={() => handleRowClick(client)}
            >
              <div className="flex flex-1 flex-row items-center gap-2">
                <AimfoxAvatar firstName={firstName} lastName={lastName} />

                <div className="flex flex-col justify-center gap-0.5">
                  <span className="line-clamp-1 break-all text-start text-sm-bold">
                    {firstName} {lastName}
                  </span>

                  <span className="line-clamp-1 break-all text-start text-xs-medium text-black-500">
                    {email}
                  </span>
                </div>
              </div>

              <Button intent="labelIcon" asChild variant="ghost-black">
                <CaretRight />
              </Button>
            </button>
          );
        })}
      </div>

      <Dialog open={isDetailsOpen} onOpenChange={setIsDetailsOpen}>
        <OverlayDialogContent>
          <MobileClientDetails client={selectedClient} />
        </OverlayDialogContent>
      </Dialog>
    </>
  );
}
